export default import.meta.ROLLDOWN_FILE_URL_5T7E4A0dBTTuVqq_9C8g1Q